import momentTimezone, { type Moment } from 'moment-timezone'

export function timeStampToMomentSafe(
    timestamp:
        | {
              _seconds: number
          }
        | null
        | undefined,
    timezone = 'Asia/Singapore'
): Moment | null {
    if (!timestamp) {
        return null
    }
    return timestampToMoment(timestamp, timezone)
}

export function timestampToMoment(
    timestamp: {
        _seconds: number
    },
    timezone = 'Asia/Singapore'
): Moment {
    const date = new Date(timestamp._seconds * 1000)
    return momentTimezone(date).tz(timezone)
}

export function nowMoment(timezone = 'Asia/Singapore'): Moment {
    return momentTimezone().tz(timezone)
}
